import { render, staticRenderFns } from "./NewMsg.vue?vue&type=template&id=796b3fe1&scoped=true"
import script from "./NewMsg.vue?vue&type=script&lang=js"
export * from "./NewMsg.vue?vue&type=script&lang=js"
import style0 from "./NewMsg.vue?vue&type=style&index=0&id=796b3fe1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b3fe1",
  null
  
)

export default component.exports